/**
 * 分享链接过期时间
 */
export const SHARE_LINK_EXPIRATION_DAYS = 7;
/**
 * 邀请协助有效期之永久
 */
export const FOREVER_TS = 9999999999999;
